import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch, IconDefinition } from "@fortawesome/free-solid-svg-icons";

export const Rotating = styled.span`
    display: inline-block;

    @keyframes rotate {
        0% {
            transform: rotateZ(0deg) scale(1.2);
        }

        100% {
            transform: rotateZ(360deg) scale(1.2);
        }
    }

    animation: rotate 2s linear 0s infinite;
`;

type SpinnerProps = {
    style?: React.CSSProperties;
    className?: string;
    icon?: IconDefinition;
};

export default function Spinner(props: SpinnerProps) {
    return (
        <Rotating style={props.style} className={props.className}>
            <FontAwesomeIcon icon={props.icon ?? faCircleNotch} />
        </Rotating>
    );
}
